import {
  FormControl,
  InputLabel,
  styled
} from '@mui/material';
import InputBase from '@mui/material/InputBase';
import { CalendarToday } from '@mui/icons-material';

const BootstrapDateInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
    fontSize: 16,
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:focus': {
    },
  },
}));

export default function BootstrapDateField({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  fullWidth = true,
  placeholder,
  error = false,
  helperText,
  showIcon = true,
  ...otherProps
}) {
  const inputId = id || `${label?.toLowerCase().replace(/\s+/g, '-')}-date`;

  return (
    <FormControl variant="standard" fullWidth={fullWidth} error={error}>
      {label && (
        <InputLabel
          shrink
          htmlFor={inputId}
          sx={{
            fontSize: '1.2rem',
            fontWeight: 500,
            color: error ? 'error.main' : 'inherit'
          }}
        >
          {label}
        </InputLabel>
      )}
      <BootstrapDateInput
        id={inputId}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        type="date"
        placeholder={placeholder}
        error={error}
        endAdornment={
          showIcon ? (
            <CalendarToday sx={{ color: '#666', fontSize: 20, mr: 1 }} />
          ) : null
        }
        {...otherProps}
      />
      {helperText && (
        <div style={{
          fontSize: '0.75rem',
          color: error ? 'red' : '#666',
          marginTop: '4px',
          marginLeft: '14px'
        }}>
          {helperText}
        </div>
      )}
    </FormControl>
  );
}
